/**
 * Created by shubham on 10/5/18.
 */

import { Component, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../../../shared/services/http.service';
import { SessionHandler } from '../../../shared/services/session-handler.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { MdDialog,MdDialogRef  } from '@angular/material';
import { DialogComponent, ShowApplicationsDialogComponent } from '../../../dialog/dialog.component';
import { CommonService } from '../../../shared/services/common.service';
import { FormGroup, FormBuilder, FormControl, Validators, AbstractControl } from '@angular/forms';
import { ManagerListPage } from "../managerList-datatable/managerList-page";
import { APPCONFIG } from '../../../config';
import { ManagerListDashboardResultService } from '../managerListDashboardResultService';
import {TranslateService} from 'ng2-translate';

@Component({
    selector: 'managerList',
    template: require('./managerList.component.html')
})
export class ManagerListComponent {

    @ViewChild(DatatableComponent) table: DatatableComponent;
    dialogRef;
    userDetails:any;
    page = new ManagerListPage();
    tableRows :any = [];
    filters:any = {};
    rows:any;
    managerListData = [];
    temp = [];
    showTable:boolean = true;
    isSystemAdmin:boolean = false;
    isBUManager:boolean = false;
    isRegionalAdmin:boolean = false;
    isServiceOwner:boolean = false;
    isTradePartner:boolean = false;
    isSubUser:boolean = false;
    selected = [];
    StatusData: any;
    CountryOrBusinessUnitData: any;
    managerListText: any;
    ManagerFiltersForm: FormGroup;
    countries = [];
    selectedStatusId: boolean;
    businessUnits = [];
    applicationList = [];
    wpassId = '';
    countryId = '';
    businessUnitId = '';
    selectedApplicationId = '';
    applicationName = '';
    dataTableMessage = {'selectedMessage':'','totalMessage':''};
    tempCountries =[{
        "id": "",
        "name": "All",
        "code": "",
        "active": true,
        "createdAt": "2019-02-26T12:49:39.329Z"
    }];
    tempBusinessUnits = [{
        "id": "",
        "name": "All",
        "codeISAM": "",
        "active": true,
        "createdAt": "2018-04-06T20:05:02.397Z",
        "updatedAt": "2018-05-31T06:41:54.303Z"
    }];

    constructor(private router: Router, private httpService:HttpService, private sessionHandler:SessionHandler, public dialog: MdDialog,
                private formBuilder: FormBuilder, private serverResultsService: ManagerListDashboardResultService, 
                private commonService: CommonService, private translate: TranslateService) {

        this.managerListText = 'managerList';

        //Assign Active or Inactive status
        this.StatusData = [
            {
                "id": true,
                "code": "ACTIVE",
                "name": "Active"
            }, {
                "id": false,
                "code": "INACTIVE",
                "name": "Inactive"
            }
        ];
        this.selectedStatusId = true;

        this.CountryOrBusinessUnitData = [
            {
                "id": 1,
                "name": "Country"
            }, {
                "id": 2,
                "name": "Business Unit"
            }
        ];

        this.page.pageNumber = 0;
        this.page.size = 20;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));

        if(this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0){
            if(this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }

        this.filters['offSet'] = this.page.pageNumber * this.page.size;
        this.filters['limit'] = this.page.size;
        if(this.isSystemAdmin){
            this.getCountries();
            this.getBusinessUnit();
            this.getApplications();
            this.getUsersList(this.filters, this.selectedStatusId, this.wpassId, this.countryId, this.businessUnitId, this.selectedApplicationId);
        } else{
            this.getUserList();
        }

        //Call when approve/delete from ApproveRejectComponent/ActiveInactiveComponent to get the updated list.
        this.commonService.managerList.subscribe((value) => {
            this.getUsersList(this.filters, this.selectedStatusId, this.wpassId, this.countryId, this.businessUnitId, this.selectedApplicationId);
        });
    }

    buildForm() {
        this.ManagerFiltersForm = this.formBuilder.group({
            selectedStatusId: this.formBuilder.control(true),
            wpassId: this.formBuilder.control(''),
            countryId: this.formBuilder.control(''),
            businessUnitId: this.formBuilder.control(''),
            selectedApplicationId: this.formBuilder.control('')
        });
        this.ManagerFiltersForm.valueChanges.subscribe(data => {
            this.selectedStatusId = this.ManagerFiltersForm.get('selectedStatusId').value;
            this.wpassId = this.ManagerFiltersForm.get('wpassId').value;
            this.countryId = this.ManagerFiltersForm.get('countryId').value;
            this.businessUnitId = this.ManagerFiltersForm.get('businessUnitId').value;
            this.selectedApplicationId = this.ManagerFiltersForm.get('selectedApplicationId').value;
        });
    }

    public getCountries(){
        this.httpService.getRequest('lookupDataOperationsApi/v1/country').subscribe(
            res => { this.saveCountries(res); },
            err => { this.httpService.onEnd(); }
        );
    }

    public saveCountries(res){
        if(res && res.items){
            this.countries = this.tempCountries.concat(res.items);
        }
    }

    public getBusinessUnit() {
        this.httpService.getRequest('lookupDataOperationsApi/v1/businessUnit').subscribe(
            res => { this.saveBusinessUnit(res); },
            err => { this.httpService.onEnd(); }
        );
    }

    saveBusinessUnit(res) {
        if(res && res.items){
            this.businessUnits = this.tempBusinessUnits.concat(res.items);
        }
    }

    public getApplications() {
        this.httpService.getRequest("applicationOperationApi/v1/applicationsForDropdown").subscribe(
            res => { this.saveApplicationsName(res); },
            err => { this.httpService.onEnd(); }
        );
    }
    public saveApplicationsName(res) {
        if (res && res.items) {
            var tempApp =[{"id": "", "code": "", "name": "all" }];
            this.applicationList = tempApp.concat(res.items);
        }
    }

    disablefields(value: String, uniqueKey) {
        if(value != ''){
            if(uniqueKey == 'wpassId'){
                this.ManagerFiltersForm.controls['selectedApplicationId'].setValue('');
                this.ManagerFiltersForm.controls['selectedApplicationId'].disable();
            } else{
                this.ManagerFiltersForm.controls['wpassId'].setValue('');
                this.ManagerFiltersForm.controls['wpassId'].disable();
            }
            this.ManagerFiltersForm.controls['businessUnitId'].setValue('');
            this.ManagerFiltersForm.controls['countryId'].setValue('');
            this.ManagerFiltersForm.controls['businessUnitId'].disable();
            this.ManagerFiltersForm.controls['countryId'].disable();
        } else{
            if(uniqueKey == 'wpassId'){
                this.ManagerFiltersForm.controls['selectedApplicationId'].enable();
            } else{
                this.ManagerFiltersForm.controls['wpassId'].enable();
            }
            this.ManagerFiltersForm.controls['businessUnitId'].enable();
            this.ManagerFiltersForm.controls['countryId'].enable();
        }
    }

    public search(){
        this.filters['offSet'] = 0;
        this.getUsersList(this.filters, this.selectedStatusId, this.wpassId, this.countryId, this.businessUnitId, this.selectedApplicationId);
    }

    public resetSearch(){
        this.ManagerFiltersForm.controls['businessUnitId'].enable();
        this.ManagerFiltersForm.controls['countryId'].enable();
        this.ManagerFiltersForm.reset();
        this.selectedStatusId = true;
        this.countryId = '';
        this.businessUnitId = '';
        this.wpassId = '';
        this.selectedApplicationId = '';
        this.buildForm();
        this.search();
    }

    public downloadBuMappingCsv() {
        let loginDataArray = JSON.parse(this.sessionHandler.getItem("loginData"));
        let accessToken;

        if (loginDataArray) {
            accessToken = loginDataArray['accessToken'];
        }
        window.open(APPCONFIG.URL + '/export?access-token=' + accessToken + '&action=bu_manager_mapping', '_blank');
    }

    public getUsersList(filter, selectedStatus, wpassId, countryId, businessUnitId, selectedApplicationId){
        this.httpService.getRequest("superUserOperationsApi/v1/countryBusinessUnitManagerMapping/list?limit="+filter.limit+"&offset="+filter.offSet+"&active="+selectedStatus+"&countryId="+countryId+"&businessUnitId="+businessUnitId+"&wpassId="+wpassId+"&selectedApplicationId="+selectedApplicationId).subscribe(
            res => { this.saveUserList(res,filter); },
            err => { this.httpService.onEnd();}
        );
    }

    public getUserList = function () {
        this.showTable = false;
    }

    public saveUserList = function(res, filter){
        if(res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'data_pull_fail';
        } else {
            if(res && Object.keys(res).length > 0 ){
                this.managerListData = res;
                this.rows = [];
                this.rows['offset'] = res.offset;

                if(this.managerListData.list) {
                    let totalCount = 0;
                    if (parseInt(res.offset) == 0) {
                        localStorage.setItem('totalCount', res.totalCount);
                        totalCount = parseInt(res.totalCount);
                    } else {
                        totalCount = parseInt(localStorage.getItem('totalCount'));
                    }

                    this.rows['totalCount'] = totalCount;
                    for (let data in this.managerListData.list) {
                        if(this.isSystemAdmin){
                            this.rows[data] = {};
                            this.rows[data]['buAssociationId'] = this.managerListData.list[data]['buAssociationId'];
                            this.rows[data]['Name'] = this.managerListData.list[data]['firstName'];
                            /*this.rows[data]['Name'] = this.managerListData.list[data]['firstName'] +' '+this.managerListData.list[data]['lastName'];*/
                            this.rows[data]['email'] = this.managerListData.list[data]['email'];
                            this.rows[data]['emailVerified'] = this.managerListData.list[data]['emailVerified'];

                            if(this.managerListData.list[data]['userId_WPASS']){
                                this.rows[data]['userId_WPASS'] = this.managerListData.list[data]['userId_WPASS'];
                            } else {
                                this.rows[data]['userId_WPASS'] = null;
                            }

                            if(this.managerListData.list[data]['pendingSubUserCount']){
                                this.rows[data]['pendingSubUserCount'] = this.managerListData.list[data]['pendingSubUserCount'];
                            }

                            if(this.managerListData.list[data]['applicationName']){
                                this.rows[data]['applicationName'] = this.managerListData.list[data]['applicationName'];
                            }

                            this.rows[data]['countryId'] = this.managerListData.list[data]['countryId'];
                            this.rows[data]['countryName'] = this.managerListData.list[data]['countryName'];
                            this.rows[data]['businessUnitId'] = this.managerListData.list[data]['businessUnitId'];
                            this.rows[data]['businessUnitName'] = this.managerListData.list[data]['businessUnitName'];
                            this.rows[data]['status'] = this.managerListData.list[data]['status'];
                            this.rows[data]['active'] = this.managerListData.list[data]['active'];
                            this.rows[data]['createdAt'] = this.managerListData.list[data]['createdAt'];
                            this.rows[data]['updatedAt'] = this.managerListData.list[data]['updatedAt'];
                        } else{
                            //For Other Service Partner's
                            this.rows[data] = {};
                        }
                    }
                    this.showTable = true;
                    this.temp = this.rows;
                } else{
                    this.showTable = false;
                }

                let finalRows = [];
                for(let f in this.rows){
                    if(f != 'offset' && f !='totalCount' && this.rows[f]){
                        finalRows.push(this.rows[f]);
                    }
                    if(f == 'offset'){
                        finalRows['offset'] = this.rows['offset'];
                    }
                    if(f == 'totalCount'){
                        finalRows['totalCount'] = this.rows['totalCount'];
                    }
                }
                this.rows = finalRows;
                this.setPage({ offset: this.rows['offset']/this.page.size },finalRows,filter);
                this.httpService.onEnd();
            }
        }
    }

    /**
     * Populate the table with new data based on the page number
     * @param page The page to select
     */
    public setPage(pageInfo,rows,filter){
        this.page.pageNumber = pageInfo.offset;
        if(rows.length != 0){
            this.serverResultsService.getResults(this.page,rows).subscribe(pageData => {
                this.page = pageData.page;
                this.tableRows = pageData.data;
                if(!filter){
                    if(Object.keys(this.tableRows).length == 0 || !this.tableRows[0]['status']){
                        this.filters['offSet'] = this.page.pageNumber * this.page.size;
                        this.getUsersList(this.filters, this.selectedStatusId, this.wpassId, this.countryId, this.businessUnitId, this.selectedApplicationId);
                    }
                }
            });
        } else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    }

    onSelect({ selected }) {
        this.selected.splice(0, this.selected.length);
        this.selected.push(...selected);
    }

    public showApplications(apps){
        this.dialogRef = this.dialog.open(ShowApplicationsDialogComponent);
        this.dialogRef.componentInstance.apps = apps;
    }

    ngOnInit(){
        this.buildForm();

        this.translate.get('total').subscribe((res: string) => {
            this.dataTableMessage.totalMessage=res;
        });
        this.translate.get('selected').subscribe((res: string) => {
            this.dataTableMessage.selectedMessage=res;
        });
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/managerAssignment/managerList/managerList.component.ts